import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const DeleteConfirmModal = ({ 
    visible, 
    onCancel, 
    onConfirm, 
    title = "Eliminar", 
    item = null,
    itemName = "",
    itemDescription = "" 
}) => {
    return (
        <Modal
            title={
                <div className="flex items-center text-red-500">
                    <ExclamationCircleOutlined className="text-xl mr-2" />
                    <span>{title}</span>
                </div>
            }
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancelar
                </Button>,
                <Button 
                    key="delete" 
                    type="primary" 
                    danger 
                    onClick={onConfirm}
                    className="hover:bg-red-700"
                >
                    Sí, Eliminar
                </Button>,
            ]}
        >
            <p>
                ¿Estás seguro que deseas eliminar {itemDescription || "este elemento"}
                {itemName ? <strong> {itemName}</strong> : ""}?
                Esta acción no se puede deshacer.
            </p>
        </Modal>
    );
};

export default DeleteConfirmModal;